// A store-to-store parcel order is identified two ways, checked together
// for safety:
//   1) orderType === 'store_to_store_parcel' — set on every parcel order
//      at creation time (see elevatemart-store's createStoreParcelOrder).
//   2) orderId starts with "SPORD" — the parcel-specific order id prefix,
//      used as a fallback in case orderType is ever missing on a doc.
//
// Regular customer orders never have orderType set and never have an
// orderId starting with "SPORD", so this can never accidentally match a
// customer order — it can only ever catch MORE parcel orders, never fewer
// (and never any customer orders).
export function isStoreParcelOrder(order) {
  if (!order) return false;

  if (order.orderType === 'store_to_store_parcel') return true;

  const orderId = order.orderId || order.id || '';
  return typeof orderId === 'string' && orderId.startsWith('SPORD');
}